'use client';

import type { ReactNode } from 'react';

import type { AssignmentCandidate } from '../types/activity-assignment';

import { ConfidenceBadge } from './ConfidenceBadge';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
interface ActivityAssignmentCandidateCardProps {
  candidate: AssignmentCandidate;
  className?: string;
  trailing?: ReactNode;
  showActivityId?: boolean;
}

export function ActivityAssignmentCandidateCard({
  candidate,
  className,
  trailing,
  showActivityId = true,
}: ActivityAssignmentCandidateCardProps) {
  return (
    <div className={cn('rounded-md border bg-muted/10 p-3', className)}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div className="min-w-0 flex-1 space-y-1">
          <p className="text-sm font-medium">{candidate.displayName}</p>
          {showActivityId ? (
            <p className="break-all font-mono text-xs text-muted-foreground">{candidate.activityId}</p>
          ) : null}
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <ConfidenceBadge confidence={candidate.confidence} size="sm" showPercentage />
          <Badge variant="outline" className="text-xs">
            {candidate.unitType}
          </Badge>
          {trailing}
        </div>
      </div>
      {candidate.reasoning ? (
        <p className="mt-2 text-xs text-muted-foreground">{candidate.reasoning}</p>
      ) : null}
    </div>
  );
}
